export default{
    getMenu(state){
        return state.menus;
    },
    getViewPost(state){
        return state.viewPost;
    },
    getRecommend(state){
        return state.recommend;
    },
    getSearchPostUserId(state){
        return state.searchpost_userId;
    },
    getSearchPostContent(state){
        return state.searchpost_content;
    },
}
